import { useState, useEffect, useRef } from "react";
import Bredcrum from "../../components/bredcrum";
import { Tag } from "primereact/tag";
import { Tablescom } from "../../components/tablescomp";
import { Toast } from "primereact/toast";

import { userservices } from "../../services/userServices";
import { productservices } from "../../services/productServices";
import { supplierservices } from "../../services/supplierServices";
import { Titlebar, Searchbox, Label } from "../../components/fieldsComp";
import { useNavigate } from "react-router";
import { useSelector } from 'react-redux';
import { manufacturerServices } from "../../services/manufacturerServices";
import { freightServices } from "../../services/freightServices";
import { MultiSelect } from 'primereact/multiselect';
import {HandleClose} from '../../helpers/formclose';
const FreightAdd = () => {
  const toast = useRef(null);
  const unitreducer = useSelector((state)=>state.unitreducer);
  const currencyreducer = useSelector((state)=>state.currencyreducer);
  const [units,setUnits] = useState([]);
  const [currencies,setCurrencies] = useState([]);
  const [productlist,setProductlist] = useState([]);
  const [errors, setErrors] = useState({});
  const [productnamesku, setProductnamesku] = useState('');
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    type: "",
    contact_person: "",
    email: "",
    phone: "",
    address: "",
  });

  useEffect(()=>{
  },[]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "Name is required";
    // if (!formData.type) newErrors.type = "Type is required";
    if (!formData.phone ) newErrors.phone = "Phone number is required";
    if (!formData.email)  newErrors.email = "Email is required";
    if (!formData.address) newErrors.address = "Address is required";
    if (!formData.contact_person) newErrors.contact_person = "Contact Person is required";
    // Add other field validations as needed

    return newErrors;
  };

  const refs = {
    name: useRef(null),
    email: useRef(null),
    phone: useRef(null),
    // date: useRef(null),
    address: useRef(null),
    contact_person: useRef(null),
    // type: useRef(null),
  };


  const [selectedServices, setSelectedservice] = useState(null);
  const services = [
      { name: 'Road', code: 'road' },
      { name: 'Air', code: 'air' },
      { name: 'Sea', code: 'sea' },
      { name: 'Courier', code: 'courier' },
      { name: 'Self Courier', code: 'self_courier'}
  ];

  const handlesubmit = (e) => {
      e.preventDefault();

      console.log(selectedServices);
        const validationErrors = validate();
          setErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) {
      // Focus first input with error
          const firstErrorKey = Object.keys(validationErrors)[0];
          if (refs[firstErrorKey]) {
            refs[firstErrorKey].current.focus();
          }
      return;
    }
    // let dataToSend = { ...formData };
const updatedFormData = { ...formData, type: selectedServices };

setLoading(true);
freightServices.createfreight(updatedFormData).then((response) => {
    setLoading(false);
    if (response.status === 200) {
        toast.current.show({ severity: 'success', summary: 'Freight', detail: 'Freight created successfully' });
    } else {
        toast.current.show({ severity: 'error', summary: 'Freight', detail: `${response.data.data}` });
    }
}).catch((error) => {
    setLoading(false);
    toast.current.show({ severity: 'error', summary: 'Manufacturer', detail: 'Error' });
});


    // Handle form submission here
  };

  // const getunits = () =>{
  //   unitreducer.then((response)=>{
  //       //  console.log(response);
  //        setUnits(response);
  //     }).catch((error)=>{
          
  //     });
  // }
  // const getproduct = () =>{
  //   productservices.getbulkproduct().then((response)=>{
  //     console.warn(response);
  //       if(response.status ==200){
  //           setProductlist(response.data.data);  
  //       }else{
  //           setProductlist([]); 
  //       }
         
  //     }).catch((error)=>{
  //           setProductlist([]); 
  //     });
  // }
  const handleClose = () => {
    // Handle close action here
  };




  return (
    <>
      <Toast ref={toast} />
      <Bredcrum title={"Freight Provider / Create Freight Provider"} divider={false} />
      <div class="row">
        {/* <div className='col-md-12 mb-4 mt-4'>
                 <div className='flex-box flex-between'>
                      <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color custom-btn-style'>Add New Product</button> 
                      <Searchbox/>
                  </div> 
              </div>  */}

        {/* <Titlebar text={"Create Freight Providers"} /> */}
        <div className="col-md-12 mt-3">
          <div className="card ps-3 pe-3">
            <div className="card-body card-body-style">
              <div className="row">
                <div className="container mt-4"></div>
                <form onSubmit={(e) => handlesubmit(e)}>

                        <div class="row mb-3">
                            <div class="col-md-6">
                              {/* <label for="name" class="form-label">Name</label> */}
                              <Label name="Name" />
                              <input type="text"  onChange={handleChange} ref={refs.name} class="form-control" id="name" name="name" placeholder="Enter Name" required/>
                              {/* {errors.name && <span style={{ color: "red" }}>{errors.name}</span>} */}
                            </div>

                            <div className="col-md-6">
                              {/* <label htmlFor="type" className="form-label">Services Type</label> */}
                              <Label name="Services Type" />
                                <div className="p-0">
                                  <MultiSelect
                                    id="type"
                                    value={selectedServices}
                                    onChange={(e) => setSelectedservice(e.value)}
                                    options={services}
                                    optionLabel="name"
                                    filter
                                    placeholder="Select Services"
                                    className="w-100"
                                    display="chip"
                                    required // or "comma", based on design
                                  />
                                </div>
                                {/* {errors.type && <span style={{ color: "red" }}>{errors.type}</span>} */}
                              </div>

                           
                        </div>

                        <div class="row mb-3">
                            <div class="col-md-6">
                              {/* <label for="contact_person" class="form-label">Contact Person</label> */}
                              <Label name="Contact Person" />
                              <input type="text"  onChange={handleChange} ref={refs.contact_person} class="form-control"
                               id="contact_person" name="contact_person" placeholder="Enter Contact Person" required/>
                              {/* {errors.contact_person && <span style={{ color: "red" }}>{errors.contact_person}</span>} */}
                            </div>

                        <div class="col-md-6">
                            {/* <label for="email" class="form-label">Email</label> */}
                            <Label name="Email" />
                            <input type="email" ref={refs.email} class="form-control" 
                            id="email" name="email" placeholder="Enter email"  onChange={handleChange} required/>
                             {/* {errors.email && <span style={{ color: "red" }}>{errors.email}</span>} */}
                         </div>
      
                        </div>

                        <div class="row mb-3">
                            <div class="col-md-6">
                              {/* <label for="phone" class="form-label">Phone</label> */}
                              <Label name="Phone" />
                              <input type="number" placeholder="Enter Phone Number" ref={refs.phone} class="form-control" id="phone" 
                              name="phone"  onChange={handleChange} required/>
                              {/* {errors.phone && <span style={{ color: "red" }}>{errors.phone}</span>} */}
                            </div>
                            <div class="col-md-6">
                              {/* <label for="address" class="form-label">Address</label> */}
                              <Label name="Address" />
                              <textarea class="form-control" placeholder="address" id="address" name="address"  onChange={handleChange} required></textarea>
                            </div>

                        </div>

                    <div class="row">
                      <div class="col-md-6">
                        <button type="submit" class="btn color-white me-2 w-100 rounded custom-btn-br-color custom-btn-color"
                         disabled={loading}>
                         {loading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" />
                                        Loading...
                                    </>
                                ) : (
                                    "Save"
                                )}
                         </button></div>
                      {<HandleClose/>}
                      </div>
                        {/* <button type="submit" class="btn color-white me-2 w-100 rounded custom-btn-br-color custom-btn-color">Submit</button> */}

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FreightAdd;

